export const log = console.log.bind(console)